<router-outlet></router-outlet>
<rk-update-available></rk-update-available>
